<script lang="ts">
    import { onMount } from "svelte";
    import { navigate } from "svelte-navigator";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { networkStore } from "../../../../store/networks";
    import { user } from "../../../../store/stores";
    import ImportStations from "./Components/ImportStations.svelte";
    import NetworkDetails from "./Components/NetworkDetailsTile.svelte";
    import NetworkMap from "./Components/NetworkMapTile.svelte";
    import NetworkTableTile from "./Components/NetworkTableTile.svelte";

    export let id: string;

    let showImport = false;

    const getNetwork = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .networkClient.getNetwork({ networkId: id })
                .then((network) => {
                    networkStore.update((networkStore) => {
                        return {
                            ...networkStore,
                            network: network,
                        };
                    });
                    return network;
                })
                .then(console.log);
        });
    };

    onMount(() => getNetwork());
</script>

<div class="container">
    <div class="columns is-multiline first-row">
        <div class="column is-one-third is-flex is-justify-content-flex-start">
            <button class="button" on:click={() => navigate(-1)}>zurück</button>
        </div>
        <div
            class="column is-one-third is-offset-one-third is-flex is-justify-content-flex-end"
        >
            <button
                class="button is-warning margin-right"
                on:click={() => (showImport = !showImport)}
                >Stationen importieren</button
            >
            <button class="button is-danger">Netz löschen</button>
        </div>
    </div>
    {#if showImport}
        <div class="columns is-centered">
            <div class="column is-one-third is-vcentered is-desktop">
                <div class="card ">
                    <ImportStations network={id} />
                </div>
            </div>
        </div>
    {/if}
    <div class="columns is-multiline">
        <div class="column is-one-third is-vcentered is-desktop">
            <div class="card network-details">
                <NetworkDetails network={$networkStore.network} />
            </div>
        </div>
        <div class="column is-two-thirds">
            <div class="card network-details">
                {#if $networkStore.network !== null}
                    <NetworkMap network={$networkStore.network} />
                {/if}
            </div>
        </div>
        <!-- <div class="column is-two-thirds">
            <div class="card network-details">
                <div class="card-content no-padding">
                    <div class="content no-padding" style="height: 15rem;">
                        <canvas id="myChart" />
                    </div>
                </div>
            </div>
        </div>
        <div class="column is-one-third">
            <div class="card network-details">
                <div class="card-content">
                    <div class="content">
                        Lorem ipsum leo risus, porta ac consectetur ac,
                        vestibulum at eros. Donec id elit non mi porta gravida
                        at eget metus. Cum sociis natoque penatibus et magnis
                        dis parturient montes, nascetur ridiculus mus. Cras
                        mattis consectetur purus sit amet fermentum.
                    </div>
                </div>
            </div>
        </div> -->
        <div class="column is-three-third">
            <div class="card network-table">
                {#if $networkStore.network}
                    <NetworkTableTile network={$networkStore.network} />
                {/if}
            </div>
        </div>
    </div>
</div>

<style>
    .container {
        padding-top: 5rem;
    }
    .network-details {
        height: 25vw;
        max-height: 25rem;
        overflow: auto;
    }

    .no-padding {
        padding: 0;
    }

    .margin-right {
        margin-right: 0.5rem;
    }
    .network-table {
        padding-top: 0;
        max-height: 48rem;
        overflow: auto;
    }
</style>
